import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as TechniekwerktIcon } from './techniekwerkt.svg';

export const Techniekwerkt = IconHOC(TechniekwerktIcon);
